import React, { useEffect, useState } from 'react';
import { Modal, Input, Select } from 'antd';
import { Account, AccountLevel } from '../../../Modules/Account/Model/Account';
import { levelKor, creatableLevels } from '../../../Utils/permission';

interface Props {
  currentUserGrade: AccountLevel;
  account: Account | null;
  open: boolean;
  onClose: () => void;
  onSubmit: (dto: Partial<Account>) => void;
}

const { Option } = Select;

const AccountEditModal = ({ currentUserGrade, account, open, onClose, onSubmit }: Props) => {
  const [form, setForm] = useState<Partial<Account>>({});
  const [isMobile, setIsMobile] = useState(false);
  const isAdmin = currentUserGrade === 'ADMIN';
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 489);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!account) return;
    // 등급(grade)은 어드민만 수정 가능하므로, 비-ADMIN은 dto에 grade를 포함하지 않게 함
    setForm(isAdmin
      ? { name: account.name, grade: account.grade, memo: account.memo }
      : { name: account.name, memo: account.memo }
    );
  }, [account, isAdmin]);

  if (!account) return null;

  const gradeOptions = isAdmin && creatableLevels(currentUserGrade).includes(account.grade)
    ? creatableLevels(currentUserGrade)
    : [];

  return (
    <Modal title="계정 수정" open={open} onCancel={onClose}
      onOk={() => onSubmit(form)} okText="수정"
      bodyStyle={isMobile ? { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' } : {}}>
      <Input placeholder="이름" value={form.name}
        onChange={e => setForm({ ...form, name: e.target.value })} />
      {gradeOptions.length > 0 && (
        <Select value={form.grade} style={{ width: '100%', marginTop: 8 }}
          onChange={(v) => setForm({ ...form, grade: v as AccountLevel })}>
          {gradeOptions.map(l => <Option key={l} value={l}>{levelKor[l]}</Option>)}
        </Select>
      )}
      <Input.TextArea rows={4} placeholder="메모" style={{ marginTop: 8 }}
        value={form.memo} onChange={e => setForm({ ...form, memo: e.target.value })} />
    </Modal>
  );
};

export default AccountEditModal;
